import { useEffect, useState } from 'react';

/**
 * The value after it stops changing, so a search box does not turn every keystroke into a request.
 *
 * @param value The live value, updated on every change.
 * @param delayMs How long to wait for quiet before publishing it.
 * @returns The settled value.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
